import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackage3UpDeksIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryPackage3UpDeksIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
